import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faDollarSign, faBriefcase, faVideo, faEnvelope, faCommentDots
} from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faWhatsapp, faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './styles/Sidebar.css';
import logo from '../components/images/logo.png';

function Sidebar() {
  return (
    <div className="sidebar">
      <div className="logo">
        <NavLink to="/">
          <img src={logo} alt="Logo" />
          <hr />
        </NavLink>
      </div>

      {/* Sidebar Content */}
      <nav>
        <ul>
          <li>
            <NavLink to="/" exact className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faHome} className="icon" />
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/pricing" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faDollarSign} className="icon" />
              Pricing
            </NavLink>
          </li>
          <li>
            <NavLink to="/gig" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faBriefcase} className="icon" />
              Gig Description
            </NavLink>
          </li>
          <li>
            <NavLink to="/videos" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faVideo} className="icon" />
              Previous Work
            </NavLink>
          </li>
          <li>
            <NavLink to="/client" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faCommentDots} className="icon" />
              Clients Review
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
              Contact Me
            </NavLink>
          </li>
        </ul>
      </nav>

      <div className="social">
        <div className="social-icons">
          <a href="https://www.instagram.com/audioeditingguy" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" /> Insta
          </a>
          <a href="https://wa.me/+923028335819" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faWhatsapp} className="social-icon" /> Whatsapp
          </a>
          <a href="https://www.facebook.com/audioeditingguy/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} className="social-icon" /> Facebook
          </a>
          <a href="https://www.fiverr.com/nauman7766" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} className="social-icon" /> Fiverr
          </a>
          <a href="https://www.linkedin.com/in/audioeditingguy/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" /> Linkedin
          </a>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
